import { TextAreaOutput } from '../../team-apis/otterdam/outputs/text-area-output';
import { OutputHelper } from './output-helper';

export class TextAreaOutputHelper extends OutputHelper<TextAreaOutput> {
  override makeRandomAnswer() {
    return Math.random().toString();
  }
}
